import React from 'react';

function AppTopNav({ activeTab, onTabChange, onSignOut }) {
  return (
    <nav className="fixed top-0 left-0 right-0 z-[100] grid grid-cols-3 items-center px-5 md:px-12 py-[14px] bg-sand-50 shadow-sm">

      {/* Left: Logo + nav links */}
      <div className="flex items-center gap-6">
        <button type="button" onClick={() => onTabChange('home')} className="flex items-center gap-[10px] focus:outline-none">
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" aria-hidden="true" className="flex-shrink-0">
            <rect width="32" height="32" rx="8" fill="#36A85B"/>
            <g transform="translate(6 6) scale(0.4167)" stroke="#FFFFFF" strokeWidth="3.6" strokeLinecap="round" strokeLinejoin="round">
              <path d="M24 5 C 13.5 13, 13.5 31, 24 43 C 34.5 31, 34.5 13, 24 5 Z"/>
              <path d="M17.5 25 L22 30 L31 16.5"/>
            </g>
          </svg>
          <span className="text-[1.0625rem] font-bold text-neutral-900 tracking-[-0.01em]">Clean Shopper</span>
        </button>
        <button type="button" onClick={() => onTabChange('home')}
          className="hidden md:block text-small text-neutral-500 hover:text-neutral-900 transition-colors duration-fast focus:outline-none">
          Home
        </button>
        <button type="button" onClick={() => onTabChange('lists')}
          className={`hidden md:block text-small transition-colors duration-fast focus:outline-none ${activeTab === 'lists' ? 'text-primary-600 font-semibold' : 'text-neutral-500 hover:text-neutral-900'}`}>
          Lists
        </button>
      </div>

      {/* Center: Search + Ask AI */}
      <div className="hidden md:flex justify-center items-center gap-3">
        <form onSubmit={(e) => { e.preventDefault(); onTabChange('search'); }} className="relative w-full max-w-[320px]">
          <svg className="absolute left-3 top-1/2 -translate-y-1/2 text-neutral-400 pointer-events-none" width="15" height="15" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
          </svg>
          <input
            type="search"
            placeholder="Search products..."
            className="w-full pl-9 pr-4 py-[5px] text-small text-neutral-800 placeholder:text-neutral-400 bg-white border border-neutral-200 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 transition-colors duration-fast"
          />
        </form>
        <button
          type="button"
          onClick={() => onTabChange('chat')}
          className={`flex items-center gap-[6px] px-4 py-[5px] text-small font-semibold border rounded-md transition-colors duration-fast focus:outline-none focus:ring-2 focus:ring-primary-500 whitespace-nowrap ${activeTab === 'chat' ? 'text-primary-700 bg-primary-200 border-primary-300' : 'text-primary-600 bg-primary-100 hover:bg-primary-200 border-primary-200'}`}
        >
          <svg width="13" height="13" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M12 2a10 10 0 1 0 0 20A10 10 0 0 0 12 2Z"/><path d="M12 8v4l3 3"/>
          </svg>
          Ask AI
        </button>
      </div>

      {/* Right: heart, profile, sign out */}
      <div className="flex justify-end items-center gap-1">
        <button type="button" onClick={() => onTabChange('lists')} aria-label="Saved products"
          className={`p-2 transition-colors duration-fast focus:outline-none focus:ring-2 focus:ring-primary-500 rounded-md ${activeTab === 'lists' ? 'text-primary-500' : 'text-neutral-500 hover:text-neutral-900'}`}>
          <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
          </svg>
        </button>
        <button type="button" aria-label="Profile"
          className="p-2 text-neutral-500 hover:text-neutral-900 transition-colors duration-fast focus:outline-none focus:ring-2 focus:ring-primary-500 rounded-md">
          <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/>
          </svg>
        </button>
        <button type="button" onClick={onSignOut}
          className="inline-flex items-center bg-primary-400 hover:bg-primary-500 text-white text-small font-bold tracking-[0.01em] px-[22px] py-[6px] rounded-md transition-colors duration-fast focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 focus:ring-offset-sand-50">
          Sign Out
        </button>
      </div>
    </nav>
  );
}

export default AppTopNav;
